import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useExperience } from '@unisporkal/experiences';
import { useTranslations } from 'app/hooks';
import { RawHtml } from '@unisporkal/utilities';
import DownArrow from 'app/images/getty/arrow-down-icon.svg';
import styles from './FeaturedMarketingArea.module.scss';

const FeaturedMarketingArea = () => {
  const fmaExperience = useExperience('FMABanner');
  const fmaInfo = useSelector((state) => state.creativeImageHomeData.fmaInfo);
  const t = useTranslations();
  const ref = useRef();

  const targetAttributeValue = () =>
    fmaInfo.open_in_new_tab ? '_blank' : '_self';
  const fontColorClass = () =>
    fmaInfo.font_color === 'black'
      ? 'square-grid-fma__font--black'
      : 'square-grid-fma__font--white';

  const fmaSubTitleMarkup = (
    <div
      className={[styles.fmaDetails, styles.fmaSubTitle, fontColorClass()].join(
        ' '
      )}
    >
      <RawHtml>{t(fmaInfo.subtitle_ilox_key)}</RawHtml>
    </div>
  );

  useEffect(() => {
    if (fmaExperience.isActive()) {
      window.tracking_data.merchandising_units = `home_fma_${fmaInfo.description
        ?.replace(/\s/g, '')
        .toLowerCase()}-shown`;
    }
  }, []);

  return (
    fmaExperience.isActive() && (
      <div
        className={styles.gridFmaContainer}
        ref={ref}
        data-testid="fma-container"
      >
        <a
          className={[
            styles.gridItemLinkFma,
            'textLinkSly',
            fontColorClass(),
          ].join(' ')}
          href={fmaInfo.linked_site_path}
          target={targetAttributeValue()}
          rel="noopener noreferrer"
          data-testid="fma-link"
        >
          <figure
            className={styles.gridItemImage}
            style={{ backgroundImage: `url(${fmaInfo.background_image_url})` }}
          />
          <h2
            className={[
              styles.fmaDetails,
              styles.fmaTitle,
              styles.fmaDetailsFullWidth,
              fontColorClass(),
            ].join(' ')}
          >
            <RawHtml>{t(fmaInfo.title_ilox_key)}</RawHtml>
          </h2>

          {fmaInfo.subtitle_ilox_key && fmaSubTitleMarkup}

          <div
            className={[
              styles.fmaDetails,
              styles.fmaDetailsFullWidth,
              styles.fmaText,
              fontColorClass(),
            ].join(' ')}
          >
            <RawHtml>{t(fmaInfo.text_ilox_key)}</RawHtml>
            <DownArrow
              style={{ transform: 'rotate(-90deg)', padding: '0 2px' }}
            />
          </div>

          {fmaInfo.logo_path && (
            <div className={styles.fmaIcon}>
              <img
                src={fmaInfo.logo_path}
                alt=""
              />
            </div>
          )}
        </a>
      </div>
    )
  );
};

export default FeaturedMarketingArea;
